import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  resolveRedirectionPath,
  getRedirection,
  hasRedirection,
} from '../services';
import { getIsAuthenticated } from '../redux';

function RedirectionProvider() {
  const navigate = useNavigate();
  const location = useLocation();
  const nextAuthenticated = useSelector(getIsAuthenticated);
  const nextLocation = location.pathname + location.search;

  const [prevLocation, setPrevLocation] = useState(nextLocation);
  const [prevAuthenticated, setPrevAuthenticated] = useState(nextAuthenticated);

  useEffect(() => {
    // sign out action
    if (!nextAuthenticated && prevAuthenticated !== nextAuthenticated) {
      setPrevAuthenticated(nextAuthenticated);
      return navigate('/login');
    }

    if (prevAuthenticated !== nextAuthenticated) {
      setPrevAuthenticated(nextAuthenticated);
    }

    if (!hasRedirection(prevLocation) && !hasRedirection(nextLocation)) {
      return setPrevLocation(nextLocation);
    }

    if (hasRedirection(prevLocation) && nextAuthenticated) {
      const redirection = getRedirection(prevLocation);
      setPrevLocation(redirection);

      return navigate(redirection);
    }

    if (hasRedirection(prevLocation) && !hasRedirection(nextLocation)) {
      const redirection = getRedirection(prevLocation);
      const path = resolveRedirectionPath(nextLocation, redirection);
      setPrevLocation(path);

      return navigate(path);
    }

    return setPrevLocation(nextLocation);
  }, [
    navigate,
    location,
    nextAuthenticated,
    nextLocation,
    prevAuthenticated,
    prevLocation,
  ]);

  return null;
}

export default RedirectionProvider;
